import { AppStreamEnvironmentLabel } from './AppStreamEnvironmentLabel';
import { AppStreamRegion } from './AppStreamRegion';

export class AppStreamEnvironment {
  customerId?: string;
  accountId?: string;
  environmentId?: string;
  name?: string;
  description?: string;
  version?: string;
  isEnabled?: boolean;
  isAvailable?: boolean;
  inMaintenanceMode?: boolean;
  statusMessage?: string | null;
  region?: AppStreamRegion;
  labels?: AppStreamEnvironmentLabel[];
  canBeSupportedByUser?: boolean;
  deploymentType?: string;
  isTelemetryEnabled?: boolean;
  clientScheme?: string | null;
  scalableServicesHealthy: boolean;
  desiredTaskCount: number;
  databaseScaleSize: string;
  inProgressScalingExecutionArn: string | null;
}
